import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment';

@Pipe({
  name: 'dateInterval'
})
export class DateIntervalPipe implements PipeTransform {

  transform(dateInterval: { dateFrom: moment.Moment, dateTo: moment.Moment }): string {
    if (!dateInterval || !dateInterval.dateFrom || !dateInterval.dateTo) {
      return null;
    }

    if (dateInterval.dateFrom.day() !== dateInterval.dateTo.day()) {
      return `${dateInterval.dateFrom.format('DD/MM/YYYY HH:mm')} - ${dateInterval.dateTo.format('DD/MM/YYYY HH:mm')}`
    } else {
      return `${dateInterval.dateFrom.format('DD/MM/YYYY HH:mm')} - ${dateInterval.dateTo.format('HH:mm')}`
    }
  }

}
